import { render, staticRenderFns, recyclableRender, components } from "./u--input.vue?vue&type=template&id=5d435ff6&"
var renderjs
import script from "./u--input.vue?vue&type=script&lang=js&"
export * from "./u--input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!E:\\前端软件\\HBuilderX.3.2.12.20211029\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

export default component.exports